import { Component, Input } from '@angular/core';
import { TargetDeviceService } from '@ids-services';
import { BaseComponent } from '@ids-components';
import { DeviceTelemetryComponent as dtComp } from '@microsec/module-device-telemetry';
import moment from 'moment';
import { of } from 'rxjs';

@Component({
  selector: 'app-device-telemetry',
  templateUrl: './device-telemetry.component.html',
  styleUrls: ['./device-telemetry.component.scss'],
  imports: [dtComp],
})
export class DeviceTelemetryComponent extends BaseComponent {
  _selectedDevice: any = null;

  get selectedDevice() {
    return this._selectedDevice;
  }

  @Input() set selectedDevice(value: any) {
    const selectedDevice = value;
    if (!!selectedDevice) {
      if (!!selectedDevice.last_seen) {
        selectedDevice.last_seen = moment
          .utc(selectedDevice?.last_seen)
          .local()
          .toISOString();
      }
    }
    this._selectedDevice = selectedDevice;
  }

  constructor(private deviceSrv: TargetDeviceService) {
    super();
  }

  telemetryAPICallback = (config: any) => {
    return config?.deviceId ? this.deviceSrv.getDeviceMetrics(config) : of(null);
  };
}
